import { render, staticRenderFns } from "./CandidateWizard.vue?vue&type=template&id=5702d090&"
import script from "./CandidateWizard.vue?vue&type=script&lang=js&"
export * from "./CandidateWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports